import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'qnect-ui-unknown-type',
    template: `
    <p style="color: red"><strong>Unknown UI Type for {{fieldId}}</strong></p>
  `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UiUnknownTypeComponent implements OnInit {

  @Input() fieldId: string;

  constructor() { }

  ngOnInit() {
  }

}
